import Vue from "vue";

/**
 * Indicador global mientras los guards del router esperan (p. ej. check-status).
 * El destino no cambia hasta que terminen los guards; sin feedback el usuario ve la pantalla "congelada".
 */
export const routerNavigationLoading = Vue.observable({
  show: false,
});

let debounceTimer = null;
let safetyTimer = null;

/** ms antes de mostrar el overlay (evita parpadeo si la red responde al instante). */
const SHOW_DELAY_MS = 120;
/** Por si un guard no termina nunca: ocultar el overlay. */
const SAFETY_MAX_MS = 45000;

export function armRouterNavigationLoading() {
  clearTimeout(debounceTimer);
  clearTimeout(safetyTimer);
  debounceTimer = setTimeout(() => {
    routerNavigationLoading.show = true;
  }, SHOW_DELAY_MS);
  safetyTimer = setTimeout(() => {
    routerNavigationLoading.show = false;
  }, SAFETY_MAX_MS);
}

export function disarmRouterNavigationLoading() {
  clearTimeout(debounceTimer);
  debounceTimer = null;
  clearTimeout(safetyTimer);
  safetyTimer = null;
  routerNavigationLoading.show = false;
}
